<app-loading-state *ngIf="loading" [compact]="true" message="Cargando detalle del crédito…"></app-loading-state>

<div class="cd-empty cd-empty--error" *ngIf="!loading && error">
  <mat-icon>error</mat-icon>
  <span>No se pudo cargar el detalle del crédito.</span>
  <button mat-stroked-button class="cf-btn" (click)="retry()">
    <mat-icon>refresh</mat-icon> Reintentar
  </button>
</div>

<div class="cd-panel" *ngIf="!loading && !error && row">
  <section class="cd-card">
    <div class="cd-card__header">
      <span class="cd-card__title"><mat-icon>account_balance</mat-icon> Situación del crédito</span>
      <app-status-pill [label]="status.label" [variant]="status.variant"></app-status-pill>
    </div>

    <div class="cd-kpis">
      <div class="cd-kpi">
        <span class="cd-kpi__label">Capital</span>
        <span class="cd-kpi__value">{{ initialAmount | number:'1.2-2' }} €</span>
      </div>
      <div class="cd-kpi">
        <span class="cd-kpi__label">Cobrado</span>
        <span class="cd-kpi__value">{{ collectedAmount | number:'1.2-2' }} €</span>
      </div>
      <div class="cd-kpi cd-kpi--accent">
        <span class="cd-kpi__label">Pendiente</span>
        <span class="cd-kpi__value">{{ pendingAmount | number:'1.2-2' }} €</span>
      </div>
    </div>

    <div class="cd-progress" *ngIf="initialAmount > 0">
      <div class="cd-progress__bar">
        <div class="cd-progress__fill" [style.width.%]="percent"></div>
      </div>
      <div class="cd-progress__legend">
        <span>Cobrado <strong>{{ percent | number:'1.0-0' }} %</strong></span>
        <span>Pendiente <strong>{{ pendingAmount | number:'1.2-2' }} €</strong></span>
      </div>
    </div>

    <div class="cd-lines" *ngIf="lines.length">
      <div class="cd-line" *ngFor="let line of lines">
        <span class="cd-line__label">{{ line.label }}</span>
        <span class="cd-line__value">{{ line.value }}</span>
      </div>
    </div>

    <div class="cd-actions">
      <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="editCredit()">
        <mat-icon>edit</mat-icon> Editar crédito
      </button>
    </div>
  </section>

  <section class="cd-card">
    <div class="cd-card__header">
      <span class="cd-card__title"><mat-icon>history</mat-icon> Movimientos</span>
      <span class="cd-card__hint">{{ yearLabel }}</span>
    </div>

    <div class="cd-block" *ngFor="let block of blocks; trackBy: trackByOperation">
      <div class="cd-block__header">
        <span class="cd-block__title"><mat-icon>{{ block.icon }}</mat-icon> {{ block.title }}</span>
        <span class="cd-block__side">
          <span class="cd-block__meta" *ngIf="block.count">{{ block.count }} · <strong>{{ block.total | number:'1.2-2' }} €</strong><ng-container *ngIf="block.note"> · {{ block.note }}</ng-container></span>
          <button *ngIf="block.canAdd" mat-stroked-button type="button" class="cf-btn cf-btn--primary cd-add" (click)="add(block)">
            <mat-icon>add</mat-icon> Añadir
          </button>
        </span>
      </div>

      <div class="cd-rows" *ngIf="block.lines.length">
        <div class="cd-row" *ngFor="let line of block.lines; trackBy: trackByUid">
          <span class="cd-row__date">{{ line.date }}</span>
          <span class="cd-row__main">
            <span class="cd-row__concept" [title]="line.concept">{{ line.concept || 'Sin concepto' }}</span>
            <span class="cd-row__meta" *ngIf="line.meta" [title]="line.meta">{{ line.meta }}</span>
          </span>
          <span class="cd-row__amount">{{ line.amount | number:'1.2-2' }} €</span>
          <span class="cd-row__actions">
            <button type="button" class="cd-icon-btn" (click)="editLine(block, line)" title="Editar" aria-label="Editar movimiento">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" class="cd-icon-btn cd-icon-btn--danger" (click)="deleteLine(block, line)" title="Eliminar" aria-label="Eliminar movimiento">
              <mat-icon>delete</mat-icon>
            </button>
          </span>
        </div>
        <button type="button" class="cd-more" *ngIf="block.count > maxLines" (click)="manage(block)">
          Ver los {{ block.count }} movimientos <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <div class="cd-block__empty" *ngIf="!block.lines.length">{{ block.empty }}</div>
    </div>
  </section>
</div>
